module.exports = __webpack_public_path__ + "static/media/noun-in-progress-556632-142350.b8118b8f.svg";